import { useState, useEffect } from 'react';

export default function AppShell({ tabs, activeTab, onTabChange, roleBadge, userName, sideBottom, children }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleTab = (id) => { onTabChange(id); setMenuOpen(false); };

  useEffect(() => {
    const handler = e => { if (e.key === 'Escape') setMenuOpen(false); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <div className="app-shell">
      {/* TOPBAR mobile */}
      <div className="topbar">
        <button className="menu-toggle" onClick={() => setMenuOpen(o => !o)}>
          {menuOpen ? '✕' : '☰'}
        </button>
        <span className="topbar-title">POLITICS SYSTEM</span>
        <span style={{ width:36 }} />
      </div>

      {/* Overlay mobile */}
      <div className={`sidebar-overlay ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)} />

      {/* Sidebar */}
      <aside className={`sidebar ${menuOpen ? 'open' : ''}`}>
        <div className="side-top">
          <img src="/favicon.ico" alt="Logo" style={{ width:40, height:40, objectFit:"contain" }} />
          <div className="side-sys">POLITICS SYSTEM</div>
          <div className="side-badge">{roleBadge}</div>
          <div className="side-name">{userName}</div>
        </div>
        <nav className="side-nav">
          {tabs.map(t => (
            <button key={t.id} className={`nav-btn ${activeTab === t.id ? 'active' : ''}`}
              onClick={() => handleTab(t.id)}>{t.label}</button>
          ))}
        </nav>
        <div className="side-bottom">{sideBottom}</div>
      </aside>

      {/* Main */}
      <main className="main-content">{children}</main>
    </div>
  );
}
